import appendVideo from "./appendVideo";
import {
    loadSpiner,
    lightboxActions,
    lightboxClean,
    subscribeButton,
    carouselCheck,
    mobileElementsAlign,
    disableEdgeButtonsObserverSetup,
} from "./smallScripts";
import handleSearchOverlayToggle from "../../component-search/js/global";
import runCustomSelect from "../js/custom-select";
import carousel from "../../carousel/js/global";
import onestoryCarousel from "../../carousel_one-story/js/global";
import responsiveNav from "../js/navigation";
import debounce from "lodash/debounce";
import {
    fbjsFacetSwitcher,
    fbjsFacetSwitcherUnticker,
} from "../js/fbjsFacetSwitcher";
import { fbjsDateNarrowing } from "../js/fbjsDateNarrowing";
import getStickyFromTop from "./sticky";
import expertiseOpen from "../../tags/js/global";
import progressBar from "../../progress-bar/js/global";
import displayDropdown from "../../redesign-submenu/js/global";
import {
    changeOpenerLang,
    checkSelectOption,
} from "../../translate-dropdown/js/global.js";
import {
    initDropdownFilters,
    handleEndMarketDropdown,
    handleGeographyDropdown,
} from "../../filters-redesign/js/global.js";
import handleFilersButtons from "../../filters/js/global.js";
import navigationRedesign from "./navigation-redesign.js";

// Global variables
let squiz = {
    fn: {
        appendVideo,
        loadSpiner,
        lightboxActions,
        lightboxClean,
        runCustomSelect,
        subscribeButton,
        carouselCheck,
    },
    vars: {
        desktopWidth: 1025,
        desktopWidthMid: 1231,
    },
};

window.squiz = squiz;
let windowWidth;

/**
 * @description - Init functions when DOM is ready
 */
document.addEventListener("DOMContentLoaded", function () {
    windowWidth = window.innerWidth;

    handleSearchOverlayToggle();
    runCustomSelect();
    responsiveNav();
    fbjsFacetSwitcher();
    fbjsFacetSwitcherUnticker();
    fbjsDateNarrowing();
    squiz.fn.subscribeButton();
    navigationRedesign();
});

window.addEventListener("load", function () {
    carousel();
    onestoryCarousel();
    getStickyFromTop();
    expertiseOpen();
    mobileElementsAlign();
    changeOpenerLang();
    checkSelectOption();
    progressBar();
    displayDropdown();
    disableEdgeButtonsObserverSetup();
    initDropdownFilters();
    handleEndMarketDropdown();
    handleGeographyDropdown();
    handleFilersButtons();
});

/**
 * @description - Browser Back/Forward navigation support (popstate)
 */
window.addEventListener("popstate", function () {
    const searchInstances = [
        "searchCS",
        "searchArticles",
        "searchBlogs",
        "searchReports",
        "searchSpotlight",
        "searchPodcasts",
        "searchViewpoints",
        "searchWebinars",
        "webinarsEvents",
        "webinarsEventsArchive",
        "searchAZ",
        "expertise",
        "searchNewsLanding",
        "searchFinancialNewsLanding",
        "searchInvestorNewsLanding",
    ];

    for (let i = 0; i < searchInstances.length; i++) {
        const instance = window[searchInstances[i]];
        if (instance && instance.search && typeof instance.doSearch === "function") {
            if (typeof instance.detectStartingParameters === "function") {
                instance.detectStartingParameters();
            }
            instance.doSearch(true, false);
            break;
        }
    }
});

/**
 * @description - Global onresize
 */
window.onresize = debounce(function () {
    if (window.innerWidth != windowWidth) {
        // Update the window width for next time
        windowWidth = window.innerWidth;

        responsiveNav();
        carouselCheck();
    }
}, 30);

const customCheckboxHandler = () => {
    const customCheckbox =
        document.querySelectorAll(".custom-checkbox-input") ?? null;
    customCheckbox &&
        customCheckbox.forEach((item) => {
            item.addEventListener("click", (e) => {
                e.currentTarget.classList.toggle("input-checked");
            });
        });
};
customCheckboxHandler();
